let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eTBQ0")).then(() => parcelRequire('88Roq'));